
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkLedgerAccountTypeEnum } from '../models/work-ledger-account-type-enum';

export function getCreateLedgerAccountDtoFormGroup() {
return new FormGroup({
    number: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(30)]),
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(255)]),
    accountType: new FormControl<WorkLedgerAccountTypeEnum | undefined>(undefined),
    active: new FormControl<boolean | undefined>(undefined),
    selectable: new FormControl<boolean | undefined>(undefined),
    approvalRequired: new FormControl<boolean | undefined>(undefined),
    isPayablesControl: new FormControl<boolean | undefined>(undefined),
    defaultCostCentreId: new FormControl<number | undefined>(undefined),
})
;
}
      